/* global axios */
import ApiClient from './ApiClient';

class TicketsAPI extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true });
  }

  get({ page = 1, since, until, q, filter } = {}) {
    const params = { page };
    if (since) params.since = since;
    if (until) params.until = until;
    if (q) params.q = q;
    if (filter && filter !== 'all') params.filter = filter;
    return super.get(params);
  }

  create(data) {
    return super.create({ ticket: data });
  }

  update(id, data) {
    return super.update(id, { ticket: data });
  }

  export(data) {
    return axios.post(`${this.url}/export`, data);
  }
}

export default new TicketsAPI();
